<tt-page *ngIf="!!setting">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card *ngIf="setting.show_businesscos_new === '1'">
            <tt-button-goto ttText="businesscos_new" ttGoto="businesscoonboarding" ttIcon="far fa-plus"></tt-button-goto>
        </tt-card>

        <tt-list [ttData]="itemsListBusinesses"></tt-list>
    </div>

    <tt-grid *ngIf="!!grid && (['tablet', 'laptop', 'desktop'] | mediaQuery)" class="flex-1" [(ttOptions)]="grid"></tt-grid>

    <tt-card class="col-xs-12 col-md-12 sp-0" *ngIf="setting.show_setting === '1'">
        <tt-button-settings></tt-button-settings>
    </tt-card>
</tt-page>
